var _a, _b;
import { makeStyles } from '@fluentui/react-components';
import { iconFilledClassName, iconRegularClassName, } from '@fluentui/react-icons';
export var useStyles = makeStyles({
    filled: (_a = {},
        _a["&.".concat(iconFilledClassName)] = {
            display: 'inline-block',
        },
        _a["&.".concat(iconRegularClassName)] = {
            display: 'none',
        },
        _a),
    regular: (_b = {},
        _b["&.".concat(iconFilledClassName)] = {
            display: 'none',
        },
        _b["&.".concat(iconRegularClassName)] = {
            display: 'inline-block',
        },
        _b),
});
//# sourceMappingURL=EdgeworthIcon.styles.js.map